module.exports = __webpack_public_path__ + "static/media/mirror.461f6638.jpg";